module.exports = __webpack_public_path__ + "img/azmin_mouth.21b61602.jpg";